import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import {AuthProvider} from './providers/auth';
import {VotingProvider} from './providers/voting';
import {CustomSnackbarProvider} from './providers/snackbar';
import ThemeProvider from './providers/theme';
import 'simplebar/dist/simplebar.min.css';

ReactDOM.render(
  <React.StrictMode>
    <CustomSnackbarProvider>
      <BrowserRouter>
        <ThemeProvider>
          <CssBaseline />
          <AuthProvider>
            <VotingProvider>
              <App />
            </VotingProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </CustomSnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
